import { WorkflowFooter } from '@/components/workflow/workflow-footer';
import { BottomNav } from '@/layouts/primary/bottom-nav';
import { Button, Flex } from '@mantine/core';
import { Icon123, IconBarcode } from '@tabler/icons-react';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useMemo, useState } from 'react';
import { useBagScanContext } from './hook';

export const ScanFooter = () => {
	const { page, setShowCodeEntry, showCodeEntry, setPage } = useBagScanContext();
	const [transitioning, setTransitioning] = useState(false);

	const shouldHideFooter = useMemo(() => {
		if (showCodeEntry) {
			return true;
		}
		return false;
	}, [showCodeEntry]);

	useEffect(() => {
		if (page === 'SCAN') {
			setTransitioning(true);
			setTimeout(() => {
				setTransitioning(false);
			}, 100);
		}
	}, [page]);

	return (
		<AnimatePresence initial={false}>
			{!shouldHideFooter && !transitioning && (
				<motion.div
					initial={{ y: 150 }}
					animate={{
						y: 0,
						transition: {
							type: 'spring',
							damping: 25,
							stiffness: 300,
							mass: 0.8,
							delay: 0.1,
						},
					}}
					exit={{
						y: 150,
						transition: {
							type: 'spring',
							damping: 30,
							stiffness: 400,
							mass: 0.6,
							duration: 0.25,
						},
					}}
					style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }}
				>
					<WorkflowFooter
						secondaryContent={
							page === 'INSTRUCTIONS' ? (
								<>
									<Flex gap="sm" pb="lg" px="md" pt="md" w="100%" justify="center">
										<Button
											bg="grey"
											c="white"
											fullWidth
											variant="filled"
											leftSection={<Icon123 />}
											onClick={() => setShowCodeEntry(true)}
											size="md"
											styles={{ label: { fontSize: '1.05rem' } }}
										>
											Enter Code
										</Button>
										<Button
											fullWidth
											variant="filled"
											onClick={() => setPage('SCAN')}
											leftSection={<IconBarcode />}
											size="md"
											styles={{ label: { fontSize: '1.05rem' } }}
										>
											Scan
										</Button>
									</Flex>
								</>
							) : null
						}
						noPad
					>
						{page === 'INSTRUCTIONS' && <BottomNav nav="home" />}
						{page === 'SCAN' && (
							<Flex gap="sm" px="md" py="md" w="100%" justify="center">
								<Button
									bg="grey"
									c="white"
									fullWidth
									variant="filled"
									leftSection={<Icon123 />}
									onClick={() => setShowCodeEntry(true)}
									size="lg"
									styles={{ label: { fontSize: '1.05rem' } }}
								>
									Enter Code
								</Button>
							</Flex>
						)}
					</WorkflowFooter>
				</motion.div>
			)}
		</AnimatePresence>
	);
};
